<template>
  <modal :title="$t('rev.header.download_powerpoint')" @hide="$emit('hide')">
    <p class="mb-4">
      {{ $t('rev.header.download_powerpoint_layout') }}
    </p>

    <v-radio-group v-model="selectedLayout" hide-details>
      <div class="layout-option mb-4">
        <v-radio data-testid="powerpoint-layout-default" value="default">
          <template v-slot:label>
            <div class="d-flex align-center">
              <v-icon color="blue-grey--darken-2" size="18" class="mr-2">
                mdi-view-agenda-outline
              </v-icon>

              <span class="font-weight-500 blue-grey--text text--darken-2">{{
                $t('rev.header.download_powerpoint_default')
              }}</span>
            </div>
          </template>
        </v-radio>

        <div class="layout-option-details ms-8">
          <p class="mb-0 body-2 blue-grey--text text--darken-3">
            {{ $t('rev.header.download_powerpoint_default_description') }}
          </p>
        </div>
      </div>

      <div class="layout-option">
        <v-radio data-testid="powerpoint-layout-detailed" value="detailed">
          <template v-slot:label>
            <div class="d-flex align-center">
              <v-icon color="blue-grey--darken-2" size="18" class="mr-2">
                mdi-view-carousel-outline
              </v-icon>
              <span class="font-weight-500 blue-grey--text text--darken-2">{{
                $t('rev.header.download_powerpoint_detailed')
              }}</span>
            </div>
          </template>
        </v-radio>
        <div class="layout-option-details ms-8">
          <p class="mb-0 body-2 blue-grey--text text--darken-3">
            {{ $t('rev.header.download_powerpoint_detailed_description') }}
          </p>
        </div>
      </div>
    </v-radio-group>

    <ModalFooter
      slot="modal-footer"
      class="mt-6 mb-2"
      okTestId="powerpoint-modal-confirm"
      cancelTestId="powerpoint-modal-cancel"
      :okText="$t('common.button.download')"
      :cancelText="$t('common.button.cancel')"
      @ok="$emit('confirm', selectedLayout)"
      @cancel="$emit('hide')"
    />
  </modal>
</template>

<script>
import Modal from '@/components/Core/Modal.vue'
import ModalFooter from '@/components/Core/ModalFooter.vue'

export default {
  name: 'DownloadPowerpointModal',

  components: {
    Modal,
    ModalFooter,
  },

  data() {
    return {
      selectedLayout: 'default',
    }
  },
}
</script>

<style scoped>
.layout-option-details {
  margin-top: -4px;
}
</style>
